let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("6xH5e")]).then(() => parcelRequire('bWkoa'));